import _default from './Rating';
export { _default as default };